/**
 * Shared UI utilities — imported or loaded before page scripts.
 * All helpers are attached to window.PropAI so page scripts can call them
 * without re-declaring the same one-liners in every file.
 */
(function () {
  const P = (window.PropAI = window.PropAI || {});

  // ── DOM helpers ────────────────────────────────────────────────────────────
  P.$ = (sel, root) => (root || document).querySelector(sel);
  P.$$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  // ── Toast ──────────────────────────────────────────────────────────────────
  P.toast = function (msg, duration) {
    const el = document.querySelector("[data-toast]");
    if (!el) return;
    const textEl = el.querySelector("[data-toast-text]") || el;
    textEl.textContent = msg;
    el.classList.add("is-show");
    clearTimeout(P.toast._t);
    P.toast._t = setTimeout(() => el.classList.remove("is-show"), duration || 1700);
  };

  // ── Sheet open / close ─────────────────────────────────────────────────────
  P.openSheet = function (idOrEl) {
    const el = typeof idOrEl === "string" ? document.getElementById(idOrEl) : idOrEl;
    if (!el) return;
    el.classList.add("is-open");
    document.body.style.overflow = "hidden";
  };
  P.closeSheet = function (idOrEl) {
    const el = typeof idOrEl === "string" ? document.getElementById(idOrEl) : idOrEl;
    if (!el) return;
    el.classList.remove("is-open");
    document.body.style.overflow = "";
  };

  // ── Chip group (single-select) ─────────────────────────────────────────────
  P.initChipGroup = function (container) {
    const btns = Array.from(container.querySelectorAll(".chip"));
    btns.forEach((b) =>
      b.addEventListener("click", () => {
        btns.forEach((x) => x.classList.remove("chip-active"));
        b.classList.add("chip-active");
      })
    );
  };

  // ── Chip group (multi-select) ──────────────────────────────────────────────
  P.initChipGroupMulti = function (container) {
    container.querySelectorAll(".chip").forEach((b) =>
      b.addEventListener("click", () => b.classList.toggle("chip-active"))
    );
  };

  // ── Segmented control ─────────────────────────────────────────────────────
  P.initSeg = function (seg) {
    const btns = Array.from(seg.querySelectorAll("button"));
    btns.forEach((b) =>
      b.addEventListener("click", () => {
        btns.forEach((x) => x.classList.remove("is-active"));
        b.classList.add("is-active");
        seg.dataset.value = b.textContent.trim().toLowerCase();
      })
    );
  };

  // ── Theme ──────────────────────────────────────────────────────────────────
  P.isLight = function () {
    return document.documentElement.getAttribute("data-theme") === "light";
  };
  P.applyTheme = function (light) {
    if (light) {
      document.documentElement.setAttribute("data-theme", "light");
    } else {
      document.documentElement.removeAttribute("data-theme");
    }
  };
  P.toggleTheme = function () {
    const next = !P.isLight();
    P.applyTheme(next);
    try { localStorage.setItem("propai:theme", next ? "light" : "dark"); } catch (_) {}
  };

  // Restore persisted theme before first paint
  try {
    const saved = localStorage.getItem("propai:theme");
    if (saved === "light") P.applyTheme(true);
    else if (saved === "system") {
      const preferLight = window.matchMedia("(prefers-color-scheme: light)").matches;
      P.applyTheme(preferLight);
    }
  } catch (_) {}

  // Auto-init on DOMContentLoaded
  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-chip-group]").forEach(P.initChipGroup);
    document.querySelectorAll("[data-chip-group-multi]").forEach(P.initChipGroupMulti);
    document.querySelectorAll("[data-seg]").forEach(P.initSeg);
  });
})();
